var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg078LeftArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.002,372.013c11.047,0,20.002-8.955,20.002-20.002V59.978c0-16.028-6.242-31.096-17.576-42.431 c-23.397-23.397-61.466-23.397-84.862,0L115.544,213.569c-23.397,23.398-23.397,61.466,0,84.862l196.022,196.022 C323.264,506.151,338.63,512,353.996,512s30.733-5.85,42.432-17.548c11.334-11.333,17.576-26.403,17.576-42.431 c0-11.047-8.955-20.002-20.002-20.002c-11.047,0-20.002,8.955-20.002,20.002c0,5.343-2.081,10.365-5.859,14.144 c-7.799,7.799-20.488,7.799-28.287,0L143.832,270.144c-7.799-7.799-7.799-20.488,0-28.287L339.854,45.835 c7.799-7.799,20.488-7.799,28.287,0c3.777,3.778,5.859,8.801,5.859,14.144v292.033C374,363.058,382.955,372.013,394.002,372.013z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg078LeftArrow1);
export default __webpack_public_path__ + "static/media/078-left-arrow-1.ac3696d761f8f616c8d682fba69dac0b.svg";
export { ForwardRef as ReactComponent };